import React from 'react';
import SEO from '../../components/SEO';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import IndustryHero from '../../components/industries/IndustryHero';
import IndustryContent from '../../components/industries/IndustryContent';
import IndustryCTA from '../../components/industries/IndustryCTA';

const InvestmentBanking = () => {
  const industryData = {
    title: 'Investment Banking',
    subtitle: 'Enterprise solutions for investment banks',
    description: 'Build secure, high-performance platforms for investment banking operations. From deal management to trading systems and research platforms, we deliver mission-critical solutions that meet the demanding requirements of investment banks.',
    challenges: [
      {
        title: 'Deal Management',
        description: 'Create comprehensive platforms for managing M&A deals, IPOs, and capital raises with workflow automation and collaboration tools.'
      },
      {
        title: 'Trading Systems',
        description: 'Develop high-frequency trading platforms with real-time data processing, order management, and risk controls.'
      },
      {
        title: 'Research & Analytics',
        description: 'Build research platforms with data aggregation, financial modeling, and report generation capabilities.'
      },
      {
        title: 'Compliance & Reporting',
        description: 'Implement systems for regulatory reporting, trade surveillance, and compliance monitoring across multiple jurisdictions.'
      }
    ],
    services: [
      'Deal Management Platforms',
      'Trading System Development',
      'Research and Analytics Tools',
      'Risk Management Systems',
      'Compliance and Reporting Solutions',
      'Data Integration and APIs'
    ],
    technologies: ['React', 'Java', 'Python', 'C++', 'PostgreSQL', 'Real-time Data', 'High-Performance Computing']
  };

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Investment Banking Technology"
        description="Custom technology for investment banking — deal management platforms, analytics dashboards, and workflow automation for capital markets."
        path="/industries/investment-banking"
      />
      <Header />
      <IndustryHero data={industryData} />
      <IndustryContent data={industryData} />
      <IndustryCTA industry="Investment Banking" />
      <Footer />
    </div>
  );
};

export default InvestmentBanking;
